<template>
  <div>
    <Card shadow>
      <Row :gutter="24">
        <Col span="4" style="display: none">
          <label style="display: flex; align-items: center">
            <span style="width: 80px">代理组:</span>
            <Select
              v-model="table.platids"
              placeholder="筛选所属平台"
              clearable
              multiple
            >
              <Option
                v-for="(item, index) in plat_list"
                :value="item.id"
                :label="item.name"
                :key="index"
              >
                {{ item.name }}
                <span style="color: #bbb">({{ item.id }})</span>
              </Option>
            </Select>
          </label>
        </Col>
        <Col span="4">
          <label style="display: flex; align-items: center">
            <span style="width: 50px">代理:</span>
            <Select
              v-model="table.app_ids"
              placeholder="选择APP盘口"
              multiple
              clearable
            >
              <Option
                v-for="(item, index) in app_list"
                :value="item.appid"
                :label="item.appName"
                :key="index"
              >
                {{ item.appName }}
                <span style="color: #bbb">({{ item.appid }})</span>
              </Option>
            </Select>
          </label>
        </Col>
        <Col span="4">
          <label style="display: flex; align-items: center">
            <span style="width: 120px">游戏类型:</span>
            <Select
              v-model="table.params.gtype"
              filterable
              placeholder="选择游戏类型"
              clearable
            >
              <Option
                v-for="item in select.GameType_List"
                :value="item.value"
                :label="item.name"
                :key="item.value"
                >{{ item.name }}</Option
              >
            </Select>
          </label>
        </Col>
        <Col span="4">
          <label style="display: flex; align-items: center">
            <span style="width: 110px">多语言分类:</span>
            <Select
              v-model="table.params.lang_type"
              filterable
              placeholder="选择多语言分类"
              clearable
            >
              <Option
                v-for="item in globalLangList"
                :value="item.value"
                :label="item.name"
                :key="item.value"
              >
                {{ item.name }}</Option
              >
            </Select>
          </label>
        </Col>
        <Col span="4">
          <label style="display: flex; align-items: center">
            <span style="width: 90px">货币分类:</span>
            <Select
              v-model="table.params.currency_type"
              filterable
              placeholder="选择货币分类"
              clearable
            >
              <Option
                v-for="item in currencyList"
                :value="item.currency"
                :label="item.name"
                :key="item.currency"
              >
                {{ item.name }}</Option
              >
            </Select>
          </label>
        </Col>
        <Col span="6">
          <label style="display: flex; align-items: center">
            <span style="width: 120px">筛选时间:</span>
            <DatePicker
              type="daterange"
              v-model="select.dataTime"
              placement="bottom-end"
              placeholder="筛选时间"
              style="width: 100%"
              :options="dateOptions"
            ></DatePicker>
          </label>
        </Col>
        <Col span="2">
          <Button type="primary" @click="gitList" :loading="loading">
            查询
            <!-- <span v-if="!loading"></span>
                        <span v-else>loading..</span>-->
          </Button>
        </Col>
      </Row>
    </Card>
    <Table
      border
      class="cenetrtable table-padding"
      :columns="table.columns"
      :data="table.data"
      style="margin-top: 12px"
      :max-height="720"
      @on-sort-change="sortChange"
      @on-column-width-resize="widthResize"
      @on-expand="onExpand"
      :row-class-name="rowClassName"
      @on-row-click="handleTableClick"
    ></Table>

    <Modal v-model="imageData.show" width="950">
      <p slot="header" style="color: #1c2438; text-align: center">
        <span>子游戏: {{ imageData.app_name }} {{ getSearchData() }}</span>
      </p>
      <div>
        <div style="display: flex; justify-content: space-between">
          <Select
            class="select"
            v-model="imageData.checkColumn"
            style="width: 200px"
            @on-change="imageIndexChange"
          >
            <Option
              v-for="(item, index) in imageData.chartSettings.labelMap"
              :value="index"
              :key="index"
              :label="item"
            ></Option>
          </Select>
          <Select
            class="select"
            v-model="imageTypeCheck"
            style="width: 200px"
            @on-change="imageTypeChange"
          >
            <Option
              v-for="(item, index) in imageTypeList"
              :value="item.index"
              :key="index"
              :label="item.name"
              :disabled="getTypeDisabled(item)"
            ></Option>
          </Select>
        </div>
        <ve-histogram
          :data="imageData.chartData"
          :settings="getChartSetting()"
          :extend="imageData.extend"
          :ref="imageData.ref"
          v-if="imageTypeCheck == 0"
        ></ve-histogram>
        <ve-pie
          :data="imageData.chartData"
          :settings="getChartSetting()"
          :extend="imageData.extend"
          v-else
          :ref="imageData.ref"
        ></ve-pie>
      </div>
    </Modal>
  </div>
</template>
<script>
import { TransTopReq } from '@/api/admin/risk'
import moment from 'moment'
import { getTableSetting, setTableSetting } from '@/libs/util'
import { tableSettingModel } from '@/libs/config'
import publicTable from '@/views/components/publicTable.vue'
import { mapState } from 'vuex'
export default {
  name: 'SubGameData',
  components: {
    publicTable,
  },
  data() {
    return {
      loading: false,
      TransTopReqTimer: null,
      tableSetting: {},
      timestamp: 0, //响应得请求结果
      otherData: {},
      imageTypeCheck: 0,
      filterArray: [
        'old_bet_user_rate',
        'old_bet_point_rate',
        'loss_rate',
        'winner_rate',
      ],
      imageTypeList: [
        { name: '柱状图', index: 0 },
        { name: '饼状图', index: 1 },
      ],
      select: {
        GameType_List: [
          { name: 'PVE游戏', value: 1 },
          { name: 'PVP游戏', value: 2 },
          { name: '捕鱼游戏', value: 3 },
          { name: '红包游戏', value: 4 },
          { name: '单机游戏', value: 5 }
          // { name: '百胜游戏', value: 8 },
          // { name: '外接游戏', value: 9 }
        ],
        dataTime: [
          this.getCurrentZeroDay(),
          new Date(new Date().setHours(23, 59, 59, 59)),
        ],
      },

      colorList: [
        '#145b7d',
        '#72baa7',
        '#78331e',
        '#f05b72',
        '#f58220',
        '#4e72b8',
        '#f26522',
        '#ed1941',
        '#694d9f',
        '#00a6ac',
        '#225a1f',
        '#f2eada',
        '#ef5b9c',
        '#2a5caa',
        '#008792',
        '#1b315e',
        '#f7acbc',
        '#11264f',
        '#ea66a6',
      ],
      tableTotal: {
        game_id: -10,
        game_name: '合计',
        _disableExpand: true,
        sub_user_num: 0,
        bet_user_rate: 1,
        bet_point: 0,
        bet_point_rate: 1,
        back_point: 0,
        percent_point: 0,
        loss_point: 0,
        loss_rate: 0,
        winner_rate: 0,
        winner_user: 0,
        loser_user: 0,
        user_point: 0,
        round_num: 0,
        play_num: 0,
        all_bet_user: 0,
        all_bet_moeny: 0,
      },
      imageData: {
        show: false,
        app_name: '',
        ref: 'subVChartImage',
        checkColumn: 'sub_user_num',
        selectColumn: this.getColumn(false).splice(0, 3),
        options: ['#32CD32', 'rgb(244, 128, 36)'],
        extend: {
          series: {
            label: {
              show: true,
              position: 'top',
              formatter: (v) => {
                if (v.seriesName.includes('比')) {
                  return this.getCustomFixed(v.value * 100) + '%'
                } else {
                  return v.value
                }
              },
            },
            itemStyle: {
              normal: {
                color: (params) => {
                  return this.colorList[
                    params.dataIndex % this.colorList.length
                  ]
                },
              },
            },
            barMaxwidth: 90,
          },
        },
        chartSettings: {
          labelMap: {
            sub_user_num: '投注人数',
            round_num: '游戏人次',
            bet_user_rate: '盘口投注人数占比',
            old_bet_user_rate: '投注人数占比',
            bet_point: '投注金额',
            bet_point_rate: '盘口投注金额占比',
            old_bet_point_rate: '投注金额占比',
            user_point: '人均投注金额',
            play_num: '人均游戏次数',
            back_point: '返奖金额',
            percent_point: '税收金额',
            loss_point: '游戏盈亏',
            loss_rate: '盈亏投注比',
            winner_rate: '赢钱人数占比',
          },
          yAxisType: ['percent'],
        },
        chartData: {
          columns: ['app_name', 'sub_user_num'],
          rows: [],
        },
      },
      //表单数据
      table: {
        params: {
          platform: 0,
          app_id: 0,
          stime: 0,
          etime: 0,
          gtype: 0,
          lang_type: '',
          currency_type: '',
        },
        platids: [],
        app_ids: [],
        data: [],
        dataObj: {},
        columns1: this.getColumn(false),
        columns: this.getColumn(true),
        expandId: null,
      },
      gameId: 0,
    }
  },
  computed: {
    ...mapState({
      currencyList: (state) => state.app.globalCurrencyList,
    }),
  },
  methods: {
    getColumn(isExpand) {
      return [
        isExpand
          ? {
              type: 'expand',
              width: 50,
              // fixed: "left",
              align: 'center',
              render: (h, params) => {
                return h(publicTable, {
                  props: {
                    row: params.row.data,
                    columns: this.table.columns1,
                  },
                })
              },
            }
          : {
              align: 'center',
              width: 50,
              // fixed: "left",
              render: (h, params) => {
                return h('span', '')
              },
            },
        {
          type: 'index',
          title: '序号',
          width: 55,
          align: 'center',
          indexMethod: (el, val) => {
            if (el.game_id == -10) {
              return ''
            } else {
              return el._index + 1
            }
          },
        },
        {
          key: 'game_name',
          align: 'center',
          width: 125,
          resizable: true,
          render: (h, params) => {
            if (!params.row.app_name) {
              return h('span', params.row.game_name)
            } else {
              return h('span', params.row.app_name)
            }
          },
          renderHeader: (h, params) =>
            this.renderHeader(
              h,
              '子游戏名称',
              '该子游戏在游戏内显示的游戏名称信息'
            ),
        },
        {
          key: 'lang_type',
          align: 'center',
          width: 125,
          resizable: true,
          renderHeader: (h, params) =>
            this.renderHeader(h, '多语言分类', '该子游戏在使用的语言'),
          render: (h, params) => {
            return h('span', this.langFilter(params.row.lang_type))
          },
        },
        {
          key: 'currency_type',
          align: 'center',
          width: 125,
          resizable: true,
          renderHeader: (h, params) =>
            this.renderHeader(h, '货币分类', '该子游戏在使用的货币'),
        },
        {
          key: 'round_num',
          align: 'center',
          sortable: 'custom',
          width: 125,
          resizable: true,
          renderHeader: (h, params) =>
            this.renderHeader(
              h,
              '游戏人次',
              '筛选时间内，筛选的子游戏的游戏人次汇总'
            ),
        },
        {
          key: 'sub_user_num',
          align: 'center',
          sortable: 'custom',
          width: 125,
          resizable: true,
          renderHeader: (h, params) => {
            return this.renderHeader(
              h,
              '投注人数',
              '显示该游戏筛选时间内投注人数；'
            )
          },
        },
        // {
        //     key: "sub_user_num",
        //     align: "center",
        //     sortable: "custom",
        //     minwidth: 125,
        //     render: (h, params) => {
        //         let value = 0;
        //         let baseValue = 0;
        //         if (params.row.data || params.row.game_id == -10) {
        //             baseValue =
        //                 this.tableTotal.all_bet_user ||
        //                 this.tableTotal.sub_user_num;
        //         } else {
        //             let find = this.table.data.find(
        //                 (el) => el.game_id == params.row.game_id
        //             );
        //             if (find) baseValue = find.sub_user_num;
        //         }
        //         value = baseValue
        //             ? (params.row.sub_user_num / baseValue) * 100
        //             : 0;
        //         return h("span", value.toFixed(2) + "%");
        //     },
        //     renderHeader: (h, params) => {
        //         return (this).renderHeader(
        //             h,
        //             "盘口投注人数占比",
        //             "显示该游戏投注人数的在总投注人数中的占比"
        //         );
        //     },
        // },
        {
          key: 'sub_user_num',
          align: 'center',
          sortable: 'custom',
          width: 125,
          resizable: true,
          render: (h, params) => {
            let value = params.row.old_bet_user_rate * 100 || 0
            if (params.row.game_id == -10 || params.row.data) {
              let baseValue =
                this.tableTotal.all_bet_user || this.tableTotal.sub_user_num
              value = baseValue
                ? (params.row.sub_user_num / baseValue) * 100
                : 0
            }
            return h('span', value.toFixed(2) + '%')
          },
          renderHeader: (h, params) => {
            return this.renderHeader(
              h,
              '投注人数占比',
              '显示该游戏盘口投注人数占比'
            )
          },
        },
        {
          key: 'bet_point',
          align: 'center',
          sortable: 'custom',
          width: 125,
          resizable: true,
          render: (h, params) => {
            return h('span', this.getCustomFixed(params.row.bet_point / 10000))
          },
          renderHeader: (h, params) => {
            return this.renderHeader(
              h,
              '投注金额',
              '筛选时间范围内该子游戏的投注金额'
            )
          },
        },
        // {
        //     key: "bet_point",
        //     align: "center",
        //     sortable: "custom",
        //     minwidth: 125,
        //     render: (h, params) => {
        //         let value = 0;
        //         let baseValue = 0;
        //         if (params.row.data || params.row.game_id == -10) {
        //             baseValue =
        //                 this.tableTotal.all_bet_moeny ||
        //                 this.tableTotal.bet_point;
        //         } else {
        //             let find = this.table.data.find(
        //                 (el) => el.game_id == params.row.game_id
        //             );
        //             if (find) baseValue = find.bet_point;
        //         }
        //         value = baseValue
        //             ? (params.row.bet_point / baseValue) * 100
        //             : 0;
        //         return h("span", value.toFixed(2) + "%");
        //     },
        //     renderHeader: (h, params) => {
        //         return (this).renderHeader(
        //             h,
        //             "盘口投注金额占比",
        //             "显示该游戏投注金额的在总投注金额中的占比"
        //         );
        //     },
        // },
        {
          key: 'bet_point',
          align: 'center',
          sortable: 'custom',
          width: 125,
          resizable: true,
          render: (h, params) => {
            let value = params.row.old_bet_point_rate * 100 || 0
            if (params.row.game_id == -10 || params.row.data) {
              let baseValue =
                this.tableTotal.all_bet_moeny || this.tableTotal.bet_point
              value = baseValue ? (params.row.bet_point / baseValue) * 100 : 0
            }
            return h('span', value.toFixed(2) + '%')
          },
          renderHeader: (h, params) => {
            return this.renderHeader(
              h,
              '投注金额占比',
              '显示该游戏盘口投注金额占比'
            )
          },
        },
        {
          key: 'user_point',
          align: 'center',
          sortable: 'custom',
          width: 125,
          resizable: true,
          render: (h, params) => {
            return h('span', this.getCustomFixed(params.row.user_point / 10000))
          },
          renderHeader: (h, params) => {
            return this.renderHeader(
              h,
              '人均投注金额',
              '显示该游戏投得人均投注金额 = 投注金额/投注人数'
            )
          },
        },
        {
          key: 'play_num',
          align: 'center',
          sortable: 'custom',
          width: 125,
          resizable: true,
          renderHeader: (h, params) =>
            this.renderHeader(
              h,
              '人均游戏次数',
              '筛选时间内，游戏次数/子游戏投注人数'
            ),
        },
        {
          key: 'back_point',
          title: '返奖金额',
          align: 'center',
          sortable: 'custom',
          width: 125,
          resizable: true,
          render: (h, params) => {
            return h('span', this.getCustomFixed(params.row.back_point / 10000))
          },
          renderHeader: (h, params) => {
            return this.renderHeader(
              h,
              '返奖金额',
              '显示该游戏筛选时间内的返奖金额'
            )
          },
        },
        {
          key: 'percent_point',
          align: 'center',
          sortable: 'custom',
          width: 125,
          resizable: true,
          render: (h, params) => {
            return h(
              'span',
              this.getCustomFixed(params.row.percent_point / 10000)
            )
          },
          renderHeader: (h, params) => {
            return this.renderHeader(
              h,
              '税收金额',
              '筛选时间范围内该游戏带来的税收金额'
            )
          },
        },
        {
          key: 'loss_point',
          align: 'center',
          sortable: 'custom',
          width: 125,
          resizable: true,
          render: (h, params) => {
            return h('span', this.getCustomFixed(params.row.loss_point / 10000))
          },
          renderHeader: (h, params) => {
            return this.renderHeader(
              h,
              '游戏盈亏',
              '显示该游戏筛选时间内的游戏盈亏金额；投注-返奖'
            )
          },
        },
        {
          key: 'loss_rate',
          align: 'center',
          sortable: 'custom',
          width: 125,
          resizable: true,
          render: (h, params) => {
            return h('span', (params.row.loss_rate * 100).toFixed(2) + '%')
          },
          renderHeader: (h, params) => {
            return this.renderHeader(h, '盈亏投注比', '盈亏金额/投注金额')
          },
        },
        {
          key: 'winner_rate',
          align: 'center',
          sortable: 'custom',
          width: 125,
          resizable: true,
          render: (h, params) => {
            return h('span', (params.row.winner_rate * 100).toFixed(2) + '%')
          },
          renderHeader: (h, params) => {
            return this.renderHeader(
              h,
              '赢钱人数占比',
              '赢家人数/（赢家+输家人数）'
            )
          },
        },
        isExpand
          ? {
              title: ' 分布图',
              align: 'center',
              minWidth: 80,
              fixed: 'right',
              render: (h, params) => {
                if (params.row.game_id > 0) {
                  return h(
                    'Button',
                    {
                      props: {
                        size: 'small',
                        type: 'primary',
                      },
                      on: {
                        click: () => {
                          this.getImageData(params.row)
                        },
                      },
                    },
                    ' 分布图'
                  )
                } else {
                  return h('span', '')
                }
              },
            }
          : {
              title: ' 分布图',
              align: 'center',
              fixed: 'right',
              minWidth: 80,
            },
      ]
    },
    closeTimer() {
      this.loading = false
      clearTimeout(this.TransTopReqTimer)
      this.TransTopReqTimer = null
    },
    openTimer() {
      this.closeTimer()
      this.loading = true
      this.TransTopReqTimer = setTimeout(() => {
        this.loading = false
      }, 100000)
    },
    //获取列表
    gitList() {
      if (this.loading) return
      this.table.data = []
      this.otherData = {}
      let list = []
      let allList = []
      let next = !!this.table.params.gtype //是否需要获取全部金额
      let paramAppArray = this.getAllHttpAppid(this.table)
      let delArray = [...paramAppArray]
      if (paramAppArray) {
        this.tableTotal.round_num = 0
        this.tableTotal.sub_user_num = 0
        this.tableTotal.bet_user_rate = 1
        this.tableTotal.bet_point = 0
        this.tableTotal.bet_point_rate = 1
        this.tableTotal.back_point = 0
        this.tableTotal.percent_point = 0
        this.tableTotal.loss_point = 0
        this.tableTotal.loss_rate = 0
        this.tableTotal.winner_rate = 0
        this.tableTotal.winner_user = 0
        this.tableTotal.loser_user = 0
        this.tableTotal.user_point = 0
        this.tableTotal.all_bet_point = 0
        this.tableTotal.all_bet_user = 0
        let httpList = []
        let allHttpList = []
        this.timestamp = new Date().getTime()
        for (let k = 0, lens = paramAppArray.length; k < lens; k++) {
          let item = paramAppArray[k]
          let app = this.app_list.find((el) => el.appid == item)
          let appName = app ? app.appName : ''
          this.table.params.stime = this.getSecond(this.select.dataTime[0])
          this.table.params.etime = this.getSecond(
            this.select.dataTime[1],
            false
          )
          // const gameItem = this.select.GameType_List.find(
          //   item => item.game_id === this.gameId
          // )
          // const gType = (gameItem && gameItem.gtype) || 0

          // console.log('gType', gType)

          let param = {
            mod: 'root',
            platid: app.platform,
            app_id: item,
            appName: appName,
            timestamp: this.timestamp,
            param: {
              _mod: 'manager',
              _func: 'GetNewGameLossInfo2',
              _param: {
                ...Object.assign({}, this.table.params, {
                  platform: app.platform,
                }),
                app_id: item,
              },
            },
          }
          if (param.param._param.gtype) {
            let param1 = this.copyData(param)
            // param1.param._param.gtype = 0
            allHttpList.push(param1)
            allList.push(1)
          }
          httpList.push(param)
        }
        if (allHttpList.length > 0) {
          let max = Math.min(5, allHttpList.length)
          for (let i = 0; i < max; i++) {
            this.toNext(allHttpList, httpList, list, allList)
          }
        } else {
          let max = Math.min(5, httpList.length)
          for (let i = 0; i < max; i++) {
            this.toHttp(httpList, list)
          }
        }
      }
    },
    async toNext(allHttpList, httpList, list, allList) {
      if (allHttpList.length > 0) {
        let param = allHttpList.shift()
        this.openTimer()
        try {
          let result = await TransTopReq(param)
          if (param.timestamp == this.timestamp) {
            result._param.data.forEach((item) => {
              this.tableTotal.all_bet_moeny += item.bet_point || 0
              this.tableTotal.all_bet_user += item.sub_user_num || 0
            })
          }
        } catch (error) {}
        allList.shift()
        if (allHttpList.length > 0) {
          this.toNext(allHttpList, httpList, list, allList)
        }

        if (allList.length == 0) {
          let max = Math.min(5, httpList.length)
          for (let i = 0; i < max; i++) {
            this.toHttp(httpList, list)
          }
        }
      }
    },
    async toHttp(httpList, list) {
      if (httpList.length > 0) {
        this.openTimer()
        let param = httpList.shift()
        let appName = param.appName
        TransTopReq(param)
          .then((res) => {
            if (param.timestamp == this.timestamp) {
              let data = res._param.data || []

              let index = list.findIndex(
                (el) => el.game_id == this.tableTotal.game_id
              )
              if (index != -1) list.splice(index, 1)
              if (data.length > 0) {
                for (let i = 0, len = data.length; i < len; i++) {
                  let el = data[i]
                  el.currency_type = res._param.currency_type
                  el.lang_type = res._param.lang_type

                  el.old_bet_user_rate = el.bet_user_rate
                  el.old_bet_point_rate = el.bet_point_rate
                  el.play_num = Math.round(el.play_rate * 100) / 100
                  this.tableTotal.sub_user_num += el.sub_user_num || 0
                  this.tableTotal.bet_point += el.bet_point || 0
                  this.tableTotal.back_point += el.back_point || 0
                  this.tableTotal.percent_point += el.percent_point || 0
                  this.tableTotal.loss_point += el.loss_point || 0
                  this.tableTotal.winner_user += el.winner_user || 0
                  this.tableTotal.loser_user += el.loser_user || 0
                  this.tableTotal.round_num += el.round_num || 0
                  this.tableTotal.bet_user_rate = this.tableTotal.sub_user_num
                    ? 1
                    : 0
                  this.tableTotal.bet_point_rate = this.tableTotal.bet_point
                    ? 1
                    : 0
                  this.tableTotal.user_point = this.calcRate(
                    this.tableTotal.bet_point,
                    this.tableTotal.sub_user_num
                  )
                  this.tableTotal.loss_rate = this.calcRate(
                    this.tableTotal.loss_point,
                    this.tableTotal.bet_point
                  )
                  this.tableTotal.winner_rate = this.calcRate(
                    this.tableTotal.winner_user,
                    this.tableTotal.winner_user + this.tableTotal.loser_user
                  )
                  this.tableTotal.play_num = this.calcRate(
                    this.tableTotal.round_num,
                    this.tableTotal.sub_user_num,
                    true
                  )
                  el.user_point = this.calcRate(el.bet_point, el.sub_user_num)

                  el.loss_rate = this.calcRate(el.loss_point, el.bet_point)
                  el.winner_rate = this.calcRate(
                    el.winner_user,
                    el.winner_user + el.loser_user
                  )
                  let child = this.copyData(el)
                  child.app_name = appName
                  let item = list.find(
                    (element) => element.game_id == el.game_id
                  )
                  if (!item) {
                    el.data = [child]
                    list.push(el)
                  } else {
                    item.data.push(child)
                    for (let key in item) {
                      if (typeof item[key] == 'number' && key != 'game_id')
                        item[key] += el[key]
                    }
                    item.user_point = this.calcRate(
                      item.bet_point,
                      item.sub_user_num
                    )
                    item.loss_rate = this.calcRate(
                      item.loss_point,
                      item.bet_point
                    )
                    item.winner_rate = this.calcRate(
                      item.winner_user,
                      item.winner_user + item.loser_user
                    )
                    item.play_num = this.calcRate(
                      item.round_num,
                      item.sub_user_num,
                      true
                    )
                  }
                }
              }
              this.requestCallBack(httpList, list)
              this.toHttp(httpList, list)
            }
          })
          .catch((error) => {
            if (param.timestamp == this.timestamp) {
              this.requestCallBack(httpList, list)
              this.toHttp(httpList, list)
            }
          })
      }
    },

    requestCallBack(list, tableData) {
      let index = tableData.findIndex(
        (el) => el.game_id == this.tableTotal.game_id
      )
      if (index != -1) tableData.splice(index, 1)
      if (tableData.length > 0) {
        tableData.push(this.copyData(this.tableTotal))
        this.table.data = tableData
      }
      if (list.length == 0) {
        this.closeTimer()
      }
    },
    onExpand(row, status) {
      this.expandId = row.game_id
      let expand = this.table.data.find((el) => el._expanded)
      if (expand) this.$set(expand, '_expanded', false)
      if (status) {
        let newEx = this.table.data.find((el) => el.game_id == row.game_id)
        if (newEx) this.$set(newEx, '_expanded', true)
      }
    },
    handleTableClick(row, index) {
      let data = this.table.data[index]
      if (this.expandId == row.game_id) {
        if (!data._expanded) this.expandId = null
      } else {
        this.table.data[index]['_userCheck'] = !data._userCheck
      }
    },
    rowClassName(row, index) {
      let data = this.table.data[index]
      return data._userCheck || data._expanded ? 'user-table-check' : ''
    },
    sortChange(params) {
      let find = this.table.data.find((el) => el._expanded)
      if (find) find._expanded = false
      let order = params.order == 'desc' ? 1 : -1
      let key = params.key
      this.table.data.sort((a, b) => {
        if (a.game_id == -10) return 1
        if (b.game_id == -10) return -1
        return a[key] * order > b[key] * order ? -1 : 1
      })
    },

    getImageData(param) {
      this.imageData.checkColumn = 'sub_user_num'
      this.imageData.chartData.columns = ['app_name', 'sub_user_num']
      let rows = this.copyData(param.data)
      rows.forEach((el) => {
        let find = this.table.data.find((item) => item.game_id == el.game_id)
        el.bet_point_rate = find.bet_point ? el.bet_point / find.bet_point : 0
        el.bet_user_rate = find.sub_user_num
          ? el.sub_user_num / find.sub_user_num
          : 0
        // el.hand_bet_user_rate = this.tableTotal.sub_user_num
        //     ? el.sub_user_num / this.tableTotal.sub_user_num
        //     : 0;
        // el.hand_bet_point_rate = this.tableTotal.bet_point
        //     ? el.bet_point / this.tableTotal.bet_point
        //     : 0;
        for (let i in el) {
          if (i.includes('_point') && !i.includes('_rate')) {
            el[i] = parseFloat(this.getCustomFixed(el[i] / 10000))
          } else if (i.includes('_rate')) {
            el[i] = parseFloat((el[i] || 0).toFixed(4))
          }
        }
      })
      this.sort(rows, 'sub_user_num')
      this.imageData.chartData.rows = rows
      this.imageData.show = true
      this.imageData.app_name = param.game_name
      this.$nextTick(() => {
        this.$refs[this.imageData.ref].echarts.resize()
      })
    },
    sort(list, val) {
      list.sort((a, b) => {
        return parseFloat(a[val]) > parseFloat(b[val]) ? 1 : -1
      })
    },
    imageIndexChange(val) {
      this.imageData.chartData.columns = [
        this.imageData.chartData.columns[0],
        val,
      ]
      if (this.filterArray.includes(val)) {
        this.imageTypeCheck = 0
      }
      this.sort(this.imageData.chartData.rows, val)
      this.$refs[this.imageData.ref].echarts.resize()
    },
    getChartSetting() {
      if (this.imageData.checkColumn.includes('_rate')) {
        return this.imageData.chartSettings
      } else {
        return Object.assign({}, this.imageData.chartSettings, {
          yAxisType: ['normal'],
        })
      }
    },
    // 分布图时间
    getSearchData(isStart = true) {
      return `(${moment(this.table.params.stime * 1000)
        .locale('zh-cn')
        .format('YYYY/MM/DD')} - ${moment(this.table.params.etime * 1000)
        .locale('zh-cn')
        .format('YYYY/MM/DD')})`
    },
    imageTypeChange() {},
    getListDisabled(key) {
      if (this.imageTypeCheck == 0) return false
      if (this.imageTypeCheck == 1) {
        return this.filterArray.includes(key)
      }
      return false
    },
    getTypeDisabled(item) {
      return this.filterArray.includes(this.imageData.checkColumn)
    },
    widthResize(val, val1, val2) {
      let { key } = val2
      this.tableSetting[key] = val
      setTableSetting(tableSettingModel.subGameData, this.tableSetting)
      let find = this.table.columns1.find((el) => el.key == key)
      if (find) {
        find.width = val
      }
    },
    initTableSetting() {
      //配置table
      this.table.columns1 = this.getColumn(false)
      this.table.columns = this.getColumn(true)
      //获取保存的配置并设置
      this.tableSetting = getTableSetting(tableSettingModel.subGameData)
      this.table.columns1.forEach((element) => {
        if (element.key && this.tableSetting[element.key]) {
          element.width = this.tableSetting[element.key]
        }
      })
      this.table.columns.forEach((element) => {
        if (element.key && this.tableSetting[element.key]) {
          element.width = this.tableSetting[element.key]
        }
      })
    },
  },

  created() {
    this.initTableSetting()
    this.gitList()
  },
}
</script>
<style lang="less">
.btn_batch {
  margin-right: 12px;
}
.cenetrtable {
  td.ivu-table-expanded-cell {
    padding: 0px !important;
  }
  .ivu-table-cell-with-expand {
    height: 30px !important;
    line-height: 30px;
  }
  .ivu-table-large {
    td {
      height: 30px !important;
    }
  }
  .ivu-table-wrapper {
    overflow: inherit !important;
  }
  .ivu-table-expanded-cell {
    padding: 0px;
  }
  .rightTop {
    position: absolute;
    right: 10px;
    top: 40px;
  }
}
</style>
